export const joinAction = '/main/join';
export const loginAction = '/main/login';
export const restorePasswordAction = '/main/RestoreRequest';
export const resetPass = '/main/restoreSubmit';
export const contactAction = '/main/contact';
export const authorizationAction = '/main/auth';
export const captchaUrl = '/main/verificationCode?2';
export const captchaRefreshUrl = '/main/refreshVerificationCode?9';
export const loadTestimonials = '/main/testimonials';
